<div [id]="'chart-container'+id" [style]="'width: 100%; height:'+(height=='100%'?'100%':height)+ ';'"></div>